export const enum ProjectSources {
    Scratch = "from scratch",
    Template = "from template",
    Form = "from custom forms",
    SampleProject = "from sample",
    Simulation = "from resource simulation",
}
